import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import { AlertTriangle, Clock } from "lucide-react";
import { api, fmtError } from "@/lib/api";
import { fmtEUR, L } from "@/constants/labels";

const T = L.versements;
const TYPE = { acompte: "Acompte", situation: "Situation", solde: "Réception / solde", retenue: "Levée de réserves" };

/** File admin — versements sans réponse du donneur d'ordre à 48 h ouvrées. Aucune action de libération ici. */
export default function AdminVersements() {
  const [data, setData] = useState({ queue_size: 0, items: [] });
  useEffect(() => { api.get("/admin/versements/queue").then((r) => setData(r.data)).catch((e) => toast.error(fmtError(e))); }, []);
  return (
    <div className="mt-4" data-testid="admin-versements">
      <div className="flex items-center gap-2 mb-3">
        <span className={data.queue_size ? "badge-danger" : "badge-valid"} data-testid="admin-versements-count">{data.queue_size} versement(s) sans réponse à 48 h ouvrées</span>
        <span className="text-xs text-[#3E4C59]">Relance + escalade automatiques. Rien n'est libéré sans décision du donneur d'ordre.</span>
      </div>
      {data.items.length === 0 && <div className="card p-6 text-center text-[#3E4C59]">Aucun versement en attente.</div>}
      <div className="space-y-2">
        {data.items.map((v) => (
          <div key={v.id} className="card p-3" data-testid={`admin-versement-${v.id}`}>
            <div className="flex items-start justify-between gap-3 flex-wrap">
              <div>
                <div className="font-semibold text-[#1F2933]">{TYPE[v.type]} · {fmtEUR(v.montant_demande_ht)} HT · Commande {v.commande_numero}</div>
                <div className="text-xs text-[#3E4C59] mt-0.5 flex flex-wrap gap-x-2">
                  <span className={T.statut[v.statut]?.[1] || "badge-muted"}>{T.statut[v.statut]?.[0] || v.statut}</span>
                  <span className="inline-flex items-center gap-1"><Clock size={11} /> échéance {new Date(v.deadline_at).toLocaleString("fr-FR")}</span>
                  {v.escalade_at && <span className="inline-flex items-center gap-1 text-[#C0392B]"><AlertTriangle size={11} /> escaladé le {new Date(v.escalade_at).toLocaleDateString("fr-FR")}</span>}
                </div>
                <div className="text-[11px] text-[#3E4C59] mt-1">Donneur d'ordre {v.entreprise_id} · Artisan {v.prestataire_id} · Mission {v.mission_id}</div>
              </div>
              <Link to={`/app/missions/${v.mission_id}/messages`} className="btn-outline text-xs">Messagerie chantier</Link>
            </div>
            <details className="mt-2 text-xs text-[#3E4C59]">
              <summary className="cursor-pointer">Traçabilité ({v.historique?.length || 0} événements)</summary>
              <ul className="mt-1 space-y-0.5">
                {(v.historique || []).map((h, i) => <li key={i} className="font-mono">{new Date(h.at).toLocaleString("fr-FR")} — {h.action}{h.event ? ` (${h.event} → ${h.to})` : ""}{h.by && h.by !== "system" ? ` — ${h.by_nom || h.by}` : ""}{h.ip ? ` — IP ${h.ip}` : ""}</li>)}
              </ul>
            </details>
          </div>
        ))}
      </div>
    </div>
  );
}
